import * as types from "./types";
import { createReducer } from "../../util/index";

const initialState = {
    loading: false,
    data: [],
};

const delayBonusSettingReducer = createReducer(initialState) ({
    [types.LISTING]: (state, action) => ({
        ...state,
        dl: action.value,
    }),
    [types.DROPDOWN]: (state, action) => ({
        ...state,
        dropDown: action.value,
    }),
    [types.STORE]: (state, action) => ({
        ...state,
        store: action.value,
    }),
    [types.DETAILS]: (state, action) => ({
        ...state,
        details: action.value,
    }),
    [types.UPDATE]: (state, action) => ({
        ...state,
        update: action.value,
    }),
});

export default delayBonusSettingReducer;